export enum KYCError {
  IdentityMismatch = 'identity_mismatch',
  FrontDocumentUnreadable = 'front_document_unreadable',
  BackDocumentUnreadable = 'back_document_unreadable',
  SelfieUnreadable = 'selfie_unreadable',
  ResidencyProofUnreadable = 'residency_proof_unreadable',
  None = 'none',
}
